import * as Tooltip from "@radix-ui/react-tooltip"; 

interface CaseSidebarTooltipProps {
  children: React.ReactNode;
  label: string;
  disabled?: boolean;
}

export function CaseSidebarTooltip({
  children,
  label,
  disabled
}: CaseSidebarTooltipProps) {

  if (disabled) {
    return <>{children}</>;
  }
  
  return (
    <Tooltip.Provider delayDuration={10} skipDelayDuration={200}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          {children}
        </Tooltip.Trigger>

        <Tooltip.Portal>
          <Tooltip.Content
            side="left"
            align="center"
            sideOffset={10}
            className="
              z-[9999] 
              max-w-[280px] 
              px-3 py-2 
              rounded-md 
              bg-[#374151] 
              text-[#FAFAFA] 
              text-xs font-normal leading-snug 
              shadow-md select-none
            "
          >
            {label}
            <Tooltip.Arrow className="fill-[#374151]" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}